const NAMESPACE = "paymentHistoryTable";

const KEYS = {
    projectNumberColumn: "projectNumberColumn",
    payerEmailColumn: "payerEmailColumn",
    payerNameColumn: "payerNameColumn",
    amountColumn: "amountColumn",
    statusColumn: "statusColumn",
    dateColumn: "dateColumn",
    changedByColumn: "changedBy",
    formColumn: "formColumn",
    recieptNumberColumn: "recieptNumberColumn",
    noPaymentHistory: "noPaymentHistory",
    closeButtonText: "closeButtonText",
    paymentHistoryDialogTitle: "paymentHistoryDialogTitle"
};

const MESSAGES = {
    [KEYS.projectNumberColumn]: {
        value: "Project Number",
        comment: "Header for the project number column"
    },
    [KEYS.payerEmailColumn]: {
        value: "Payer Email",
        comment: "Header for the payer email column"
    },
    [KEYS.payerNameColumn]: {
        value: "Payer Name",
        comment: "Header for the payer name column"
    },
    [KEYS.amountColumn]: {
        value: "Amount",
        comment: "Header for the amount column"
    },
    [KEYS.statusColumn]: {
        value: "Status",
        comment: "Header for the status column"
    },
    [KEYS.dateColumn]: {
        value: "Date",
        comment: "Header for the date column"
    },
    [KEYS.changedByColumn]: {
        value: "Changed By",
        comment: "Header for the changed by column"
    },
    [KEYS.formColumn]: {
        value: "Form",
        comment: "Header for the form column"
    },
    [KEYS.recieptNumberColumn]: {
        value: "Receipt Number",
        comment: "Header for the reciept number column"
    },
    [KEYS.noPaymentHistory]: {
        value: "No payment history",
        comment: "Message to display if no data in payment history table"
    },
    [KEYS.closeButtonText]: {
        value: "Close",
        comment: "Text for close button on export ePayments download dialog"
    },
    [KEYS.paymentHistoryDialogTitle]: {
        value: "Payment History",
        comment: "title for payment history dialog"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
